import { useDragSlider } from './dragSlider.hooks';
import { IDragSlider } from './interfaces';
import { Slider } from './Slider/Slider';

const DragSlider = ({
  children,
  bounceStiffness,
  bounceDamping,
  childRef,
  activeSlide,
  setActiveSlide,
  margin,
}: IDragSlider) => {
  const {
    ref,
    x,
    sliderConstraints,
    visibleSliderWidth,
    singleSlideWidth,
    trueSliderWidth,
    childrenCount,
  } = useDragSlider(childRef, children);
  return (
    <Slider
      sliderRef={ref}
      x={x}
      sliderConstraints={sliderConstraints}
      bounceStiffness={bounceStiffness}
      bounceDamping={bounceDamping}
      visibleSliderWidth={visibleSliderWidth}
      singleSlideWidth={singleSlideWidth}
      setActiveSlide={setActiveSlide}
      trueSliderWidth={trueSliderWidth}
      activeSlide={activeSlide}
      childrenCount={childrenCount}
      margin={margin}
    >
      {children}
    </Slider>
  );
};

export { DragSlider };
